<style scoped>
.weixin{
    position: fixed;
    top: 60px;
    right: 20px;
}
.tag-level{
    width: 10px;
    height: 10px;
    background-color: white;
    border-radius: 50%;
    border: 5px solid;
    display: inline-block;
    white-space: nowrap;
}
.tag-level-span{
    font-size: small;
    margin-left: 13px;
    margin-top: -9px;
}
.tag-level-station{
    font-size: small;
    margin: 0 10px;
    width: 10px;
}
.tag-asset{
    font-size: 14px;
    margin-right: 10px;
    padding: 2px 5px;
    margin-bottom: 2px;
}
.link-active{
    border: 1px solid #FF8D5B;
}
.asset-title{
    display: inline-block;
    padding-left: 30px;
    vertical-align: top;
    padding-top: 30px;
}
.asset-title-p{
    width:10px;
    position: relative;
}
.asset-content{
    display: inline-block;
    border-left: 1px solid gray;
    margin-left: 20px;
    height: 100%;
}
.asset-line{
    position: relative;
    width: 100%;
}
.asset-staion{
    display: inline-block;
}
.asset-button-sort-active{
    border: 1px solid #FF8D5B;
}
.asset-button-sort{
    position: relative;
}
.asset-button-text{
    width: 15px;
    cursor: pointer;
}
.asset-button-text:hover{
    color: #FF8D5B;
}
.asset-botton{
    display: inline-block;
    position: relative;
    margin-left: 30px;
}
.asset-report{
    width: 300px;
    display: inline-block;
    margin-left: 10px;
    vertical-align: middle;
}
.asset-remark{
    display: inline-block;
    vertical-align: middle;
    margin-left: -50px
}
.errormsg{
  text-align: center;
  padding-top: 100px;
  font-size: x-large;
  color: gray;
}
</style>

<template>
    <div style="padding-bottom: 50px;position: relative;">
      <header v-title data-title="站点静态指数研究"/>

        <Row class="text-center p-t-10">
            <i-col>
                <Select v-model="chooseProvince" class="p-l-5" style="width:200px" @on-change="handleChangeProvince">
                    <Option v-for="item in provinceList" :value="item.provinceCode" :key="item.provinceCode">{{ item.provinceName }}</Option>
                </Select>
                <Select v-model="chooseCity" class="p-l-5" style="width:200px" @on-change="handleChangeCity">
                    <Option v-for="item in cityList" :value="item.cityCode" :key="item.cityCode">{{ item.cityName }}</Option>
                </Select>
                <Select v-model="chooseLevel" class="p-l-5" style="width:200px" @on-change="handleSearch(orderBy)">
                    <Option v-for="item in levelList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                <Button :type="orderBy === 1? 'warning' : 'info'" class="m-l-5" @click="handleSearch(1)">按上下行排序</Button>
                <Button :type="orderBy === 2? 'warning' : 'info'" class="m-l-5" @click="handleSearch(2)">按等级排序</Button>

                <Button type="primary" class="m-l-5" @click="handelGenerateImg">生成图片并下载（demo）</Button>
            </i-col>
        </Row>

        <Row style="padding: 20px 100px;line-height: 25px;">
            <a v-for="(asset,index) in assetList" :key="asset.assetId" class="tag-asset" :class="asset.checked? 'link-active':''" @click="handleChangeCheckLines(asset,index)">
                {{asset.assetName}}
            </a>
        </Row>

        <Row class="text-center">
            <div v-for="index of chooseLevel" :key="index" class="tag-level" :style="{'border-color': colors[4 - chooseLevel + index], 'margin': '0 30px'}">
              <div class="tag-level-span">
                {{index}}级 <span v-if="index=== chooseLevel">(最优)</span>
              </div>
            </div>
        </Row>

        <Row v-for="(item,i) in stationList" :key="i" :id="'assetStationsRank' + i">
            <div class="asset-title">
                <p class="asset-title-p">
                    <strong>{{item.assetName}}</strong>
                </p>
            </div>

            <div class="asset-content">
                <div class="asset-line p-t-20">
                    <div v-for="(station,index) in item.stations" :key="index" class="asset-staion">
                        <div class="tag-level-station">
                            <span v-if="index%2>0">{{station.stationName}}</span>
                            <span v-else>&nbsp;</span>
                        </div>
                    </div>
                </div>

                <div class="asset-line p-b-10">
                    <div v-for="(station,index) in item.stations" :key="index" class="asset-staion">
                        <div class="tag-level" :style="{'border-color': colors[4 - chooseLevel + station.rank], 'margin': '0 10px'}"></div>
                    </div>
                    <hr style="margin-top: -11px"/>
                </div>

                <div class="asset-line">
                    <div v-for="(station,index) in item.stations" :key="index" class="asset-staion" style="vertical-align: top;">
                        <div class="tag-level-station">
                            <span v-if="index%2===0">{{station.stationName}}</span>
                            <span v-else>&nbsp;</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="asset-report">
                <div style="width:100%;height:150px;" :id="'serviceReport'+i"></div>
            </div>

            <div class="asset-remark">
              <p v-for="(levelLable,index) in statisticLevel(item.stations)" :key="index">{{levelLable.label}}</p>
            </div>
        </Row>

        <p v-if="errorMsg!==''" class="errormsg">{{errorMsg}}</p>
        <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
</template>

<script>
import { getCityInfo, getAssetInfo, getRankInfo } from '@/api/dw'
import html2Canvas from 'html2canvas'
import echarts from 'echarts'

export default {
  data () {
    return {
      cityInfo: null,
      provinceList: [],
      chooseProvince: null,
      cityList: [],
      chooseCity: null,
      levelList: [
        { value: 2, label: '分2级' },
        { value: 3, label: '分3级' },
        { value: 4, label: '分4级' },
        { value: 5, label: '分5级' }
      ],
      chooseLevel: 3,
      assetList: [],
      chooseAssets: [],
      stationList: [],
      errorMsg: '',
      colors: ['#808695', '#19be6b', '#2d8cf0', '#ff9900', '#ed4014'],
      spinShow: false,
      isFirstLoad: true,
      orderBy: 1
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      getCityInfo().then(res => {
        this.cityInfo = res
        this.provinceList = this.cityInfo.map(x => {
          return {
            provinceCode: x.provinceCode,
            provinceName: x.provinceName
          }
        })
        this.chooseProvince = this.provinceList[0].provinceCode
        this.handleChangeProvince()
      })
    },
    handleChangeProvince () {
      this.cityList = this.cityInfo.find(x => x.provinceCode === this.chooseProvince).cities
      this.chooseCity = this.cityList[0].cityCode

      this.handleChangeCity()
    },
    handleChangeCity () {
      let query = { cityCode: this.chooseCity }
      getAssetInfo(query).then(res => {
        if (res.length > 0) {
          this.assetList = res.map(x => {
            return { assetId: x.assetId, assetName: x.assetName, checked: false }
          })

          this.errorMsg = ''
          if (this.isFirstLoad) {
            this.isFirstLoad = false
            this.assetList[0].checked = true
            this.handleSearch(1)
          }
        } else {
          this.errorMsg = '当前城市没有特征数据，无法评定站台等级'
          this.assetList = []
        }
      })
    },
    handleChangeCheckLines (line, i) {
      if (line.checked && this.assetList.filter(x => x.checked).length < 2) {
        this.$Notice.warning({ desc: '至少需要一个线路' })
        return
      }

      line.checked = !line.checked
    },
    handleSearch (orderBy) {
      this.orderBy = orderBy
      let query = {
        assetIds: this.assetList.filter(x => x.checked).map(x => x.assetId).join(','),
        k: this.chooseLevel,
        order: orderBy
      }

      this.spinShow = true
      getRankInfo(query).then(res => {
        if (res.errorCode) {
          this.stationList = []
          this.errorMsg = res.errorMsg
        } else {
          this.stationList = res
          this.errorMsg = ''
          this.formatReportData()
        }
        this.spinShow = false
      }).catch(() => {
        this.spinShow = false
      })
    },
    formatReportData () {
      let index = 0
      this.stationList.forEach(element => {
        let seriesData = []
        let total = element.stations.length // 总站点数
        let ranks = [] // 级别数
        element.stations.forEach(station => {
          if (ranks.indexOf(station.rank) === -1) {
            ranks.push(station.rank)
          }
        })
        ranks = ranks.sort(function (a, b) {
          return a > b ? 1 : -1
        })

        let rankIndex = 0
        ranks.forEach(rank => {
          let startSize = (100 - 15 * rankIndex) + '%'
          let endSize = (90 - 15 * rankIndex) + '%'

          seriesData.push({
            name: rank + '级', // 系列名称
            type: 'pie', // 饼图
            hoverAnimation: false, // 是否开启hover(悬停)在扇区上的放大动画效果
            radius: [startSize, endSize], // 饼图的半径,第一项是内半径，第二项是外半径
            color: this.colors[4 - this.chooseLevel + rank],
            labelLine: {// 标签的视觉引导线
              normal: {
                show: false
              }
            },
            data: [// 系列中的数据内容数组
              {
                value: element.stations.filter(x => x.rank === rank).length,
                itemStyle: {
                  normal: {
                    color: this.colors[4 - this.chooseLevel + rank]// 柱图显示颜色
                  }
                }
              },
              {
                value: total - element.stations.filter(x => x.rank === rank).length,
                itemStyle: {
                  normal: {
                    color: 'RGBA(0,186,255,0)'// 柱图透明色
                  }
                }
              }
            ]
          })
          rankIndex++
        })

        this.initReport('serviceReport' + index, seriesData)
        index++
      })
    },
    initReport (reportName, seriesData) {
      this.$nextTick(() => {
        var dataSourcePie = echarts.init(document.getElementById(reportName))
        dataSourcePie.setOption({ // 通过setOption来生成饼图
          tooltip: {// 提示框组件
            show: true,
            // 触发类型[item-数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用]
            trigger: 'item',
            formatter: '{a}数量: {c} (占比{d}%)'// 提示框格式器。
            // 饼图: {a}（系列名称），{b}（数据项名称），{c}（数值）, {d}（百分比）
          },
          series: seriesData
        }, true)

        window.addEventListener('resize', function () {
          dataSourcePie.resize()
        })
      })
    },
    statisticLevel (stations) {
      let ranks = [] // 级别数
      let levelLable = []
      stations.forEach(station => {
        if (ranks.indexOf(station.rank) === -1) {
          ranks.push(station.rank)
        }
      })
      ranks = ranks.sort(function (a, b) {
        return a > b ? 1 : -1
      })
      ranks.forEach(rank => {
        levelLable.push({
          color: this.colors[4 - this.chooseLevel + rank],
          label: rank + '级数量: ' + stations.filter(x => x.rank === rank).length + ' (占比' + (stations.filter(x => x.rank === rank).length * 100 / stations.length).toFixed(2) + '%)'
        })
      })

      return levelLable
    },
    handelGenerateImg () {
      let ele = document.getElementById('assetStationsRank' + 0)

      html2Canvas(ele).then(canvas => {
        let imgData = canvas.toDataURL()
        let link = document.createElement('a')
        link.href = imgData
        link.download = 'test.png'
        link.click()
      })
    }
  }
}
</script>
